export default __webpack_public_path__ + "static/logo-d4ff01a08ef3eaad66d8bbe846ede833.png";